import URL from '../api_url';

export const SESSION_BEHAVIOR_OBSERVATION_API = `${URL}/behavior-session-observation`;

export const SESSION_BEHAVIOR__OBSERVATIONS_API = `${URL}/behavior-session-observations`;
